/// <reference path="../TypeLite.Net4.d.ts" />

import Models = Gf.Web.Models;

export interface IRouteProps {
    params: { [key: string]: string };
}

export type FeltErrors = { [feltType: string]: string };

export interface ILoaderProps {
    readonly params: { [key: string]: string}
    readonly laster?: IModelLaster;
}

// Date while loading, null when loaded
export type Resources = { [path: string]: Date | null };

export class FeltError {
    constructor(public readonly felt: string | undefined, public readonly melding: string) { }
}

export interface ILoaderState {
    resources: Resources;
    errors: FeltErrors;
}

export interface IListeProps<TModel> {
    liste: TModel[];
}

export const norskDatoFormat = "DD.MM.YYYY";

export interface IValgLaster {
    finnValg<TFeltType>(valgKontekt: Models.ValgKontekst<TFeltType>): Gf.Web.Models.FeltValg[] | undefined;
}

export interface IModelLaster extends IValgLaster, IDataRequesterHandler {
    readonly routeComponent: IRouteComponent;
    readonly resources: Resources;
    removeHandlers(): void;
    updateResource(path: string, loaded: boolean): void;
    loadingSince(): Date | null;
    last<T>(path: string): T | undefined;
}

export interface IRouteComponent {
    readonly laster: IModelLaster;
    updateState(): void;
    getError(key: string): string | undefined;
    setError(key: string, error: string | undefined): void;
    setErrors(errors: FeltError[]): void;
    getErrors(): FeltError[];
    // TODO: Find a more elegang way
    handleError(felt: string | undefined, error: Models.ApiError): void;
}

export interface IModelHandler<TFeltType> extends IRouteComponent {
    laster: IModelLaster;
    formError(error: Gf.Web.Models.ApiError, feltType: TFeltType): void;

    onBlur(felt: Models.FeltMedVerdi<TFeltType> | undefined, entitetType: Gf.Dom.Type.EntitetType | undefined, feltType: TFeltType, gammelVerdi: any, nyVerdi: any, focused: boolean, target: any): void;
    onFocus(entitetType: Gf.Dom.Type.EntitetType | undefined, feltType: TFeltType, gammelVerdi: any, target: any): void;
}

// TODO: Slett denne metoden
export function entitetPath(entitetType: Gf.Dom.Type.EntitetType): string | undefined {
    switch (entitetType) {
    case Gf.Dom.Type.EntitetType.Aktør:
        return "Aktor";
    case Gf.Dom.Type.EntitetType.Polise:
        return "Polise";
    case Gf.Dom.Type.EntitetType.Faktura:
        return "Faktura";
    }
    return undefined;
}

export interface IDataRequester {
    get(url: string, consumer: (result: any, error: any) => void): void;
    post(url: string, request: any, consumer: (result: any, error: any) => void): void;
}

export interface IDataRequesterHandler {
    handleDataResponse(response: any, error: any, resourceUrl: string): void;
}

export interface IDataRequestResult<T> {
    readonly value: T | null;
    readonly error: Models.ApiError | null;
}

export enum DataRequesterCacheEntryState {
    Invalid,
    Fetching,
    Fetched
}

export function enkelFeil(error: Models.ApiError, felt: string | undefined, handler: IRouteComponent | undefined) {
    if(handler) {
        handler.handleError(felt, error);
    }
}

export function feltFeil<TFeltType>(error: Models.ApiError, feltType: TFeltType, handler: IRouteComponent) {
    enkelFeil(error, feltType ? `${feltType}` : undefined, handler);
}

export function arrayEquals<T>(array1: T[], array2: T[]) {
    // if the other array is a falsy value, return

    // compare lengths - can save a lot of time
    if (array1.length !== array2.length)
        return false;

    let i = 0;
    const l = array1.length;
    for (; i < l; i++) {
        if (array1[i] !== array2[i]) {
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;
        }
    }
    return true;
}

export function objectEquals(object1: any, object2: any): boolean {
    //For the first loop, we only check for types
    for (const propName in object1) {
        //Check for inherited methods and properties - like .equals itself
        //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/hasOwnProperty
        //Return false if the return value is different
        if (object1.hasOwnProperty(propName) !== object2.hasOwnProperty(propName)) {
            return false;
        }
        //Check instance type
        else if (typeof object1[propName] !== typeof object2[propName]) {
            //Different types => not equal
            return false;
        }
    }
    //Now a deeper check using other objects property names
    for(const propName in object2) {
        //We must check instances anyway, there may be a property that only exists in object2
        //I wonder, if remembering the checked values from the first loop would be faster or not
        if (object1.hasOwnProperty(propName) !== object2.hasOwnProperty(propName)) {
            return false;
        }

        const value1 = object1[propName];
        const value2 = object2[propName];
        if (typeof value1 !== typeof value2) {
            return false;
        }
        //If the property is inherited, do not check any more (it must be equa if both objects inherit it)
        if(!object1.hasOwnProperty(propName))
            continue;

        //Now the detail check and recursion

        //object1 returns the script back to the array comparing
        /**REQUIRES Array.equals**/
        if (value1 instanceof Array && value2 instanceof Array) {
            // recurse into the nested arrays
            if (!arrayEquals(value1, value2)) {
                return false;
            }
        }
        else if (value1 instanceof Object && value2 instanceof Object) {
            // recurse into another objects
            //console.log("Recursing to compare ", object1[propName],"with",object2[propName], " both named \""+propName+"\"");
            if (!objectEquals(value1, value2)) {
                return false;
            }
        }
        //Normal value comparison for strings and numbers
        else if(value1 !== value2) {
            return false;
        }
    }
    //If everything passed, let's say YES
    return true;
}

// How long to wait before showing spinner for async operations
export const spinnerDelayMs = 1000;


// WEBPACK FOOTER //
// ./Scripts/React/domene.ts